module.exports = __webpack_public_path__ + "static/media/ColorLogoOutline.d403bd76.png";